// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"b72484f8","64":"9bc9ee72","195":"fcb016cc","240":"60757826","256":"444d3d0d","388":"dd469515","561":"4de7b3ba","585":"2aa61800","598":"73760683","645":"070af605","720":"071da524","761":"d7540682","807":"cdb12217","827":"2ebec286"}[chunkId] + ".chunk.js";
};